import { c as _c } from "react/compiler-runtime";
import Modal, { ModalContent, ModalHeader } from '../../components/HOC/Modal';
interface SidebarItem {
  icon: React.ReactNode;
  text: string;
  component?: React.ReactNode;
  dataId?: string;
  action?: React.ReactNode;
}
type Props = {
  activeComponent: SidebarItem;
  onClose: () => void;
};
const MobileSidebarModal = t0 => {
  const $ = _c(11);
  const {
    activeComponent,
    onClose
  } = t0;
  let t1;
  if ($[0] !== activeComponent.text) {
    t1 = <h2>{activeComponent.text}</h2>;
    $[0] = activeComponent.text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== t1) {
    t2 = <ModalHeader closeHandler={onClose}>{t1}</ModalHeader>;
    $[2] = onClose;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeComponent.component) {
    t3 = <ModalContent>{activeComponent.component}</ModalContent>;
    $[5] = activeComponent.component;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClose || $[8] !== t2 || $[9] !== t3) {
    t4 = <Modal closeHandler={onClose}>{t2}{t3}</Modal>;
    $[7] = onClose;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default MobileSidebarModal;